(function () {
  function init() {
    var grid = document.querySelector('#product-grid');
    if (!grid) return;

    var loading = false;
    var observer = null;

    var paginationWrapper = document.querySelector('.pagination-wrapper');
    if (paginationWrapper) {
      paginationWrapper.style.visibility = 'hidden';
      paginationWrapper.style.height = '0';
      paginationWrapper.style.overflow = 'hidden';
      paginationWrapper.style.margin = '0';
      paginationWrapper.style.padding = '0';
    }

    var spinner = document.createElement('div');
    spinner.className = 'inf-spinner';
    spinner.innerHTML = '<div class="inf-spinner__ring">&nbsp;</div>';
    grid.insertAdjacentElement('afterend', spinner);

    function nextHref() {
      var a = document.querySelector('.pagination--next a');
      return a ? a.href : null;
    }

    function lastItem() {
      var items = grid.querySelectorAll(':scope > .grid__item');
      return items.length ? items[items.length - 1] : null;
    }

    function watch() {
      if (observer) observer.disconnect();
      if (!nextHref()) return;
      var last = lastItem();
      if (!last) return;
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadMore();
      }, { rootMargin: '0px 0px 300px 0px' });
      observer.observe(last);
    }

    async function loadMore() {
      var href = nextHref();
      if (!href || loading) return;
      loading = true;
      spinner.classList.add('active');

      try {
        var res = await fetch(href);
        var text = await res.text();
        var doc = new DOMParser().parseFromString(text, 'text/html');

        doc.querySelectorAll('#product-grid > .grid__item').forEach(function (item) {
          grid.appendChild(item);
        });

        var newPag = doc.querySelector('.pagination-wrapper');
        if (paginationWrapper) {
          paginationWrapper.innerHTML = newPag ? newPag.innerHTML : '';
        }
      } catch (e) {
        console.error('[infinite-scroll]', e);
      } finally {
        loading = false;
        spinner.classList.remove('active');
        watch();
      }
    }

    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
